"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = _interopRequireDefault(require("../../colors"));

require("./Alert.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var typeColor = function typeColor(type) {
  switch (type) {
    case 'primary':
      return _colors["default"].brand_1;

    case 'secondary':
      return _colors["default"].brand_3;

    case 'info':
      return _colors["default"].info;

    case 'success':
      return _colors["default"].success;

    case 'warning':
      return _colors["default"].warning;

    case 'danger':
      return _colors["default"].danger;

    case 'light':
      return _colors["default"].brand_4;

    case 'dark':
      return _colors["default"].white;

    default:
      return '';
  }
};

var Alert = function Alert(_ref) {
  var children = _ref.children,
      title = _ref.title,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["children", "title", "type"]);

  var alertClassNames = (0, _classnames["default"])({
    'kt-alert': true,
    'kt-alert-light': type === 'light',
    'kt-alert-dark': type === 'dark'
  });
  var color = typeColor(type);
  return _react["default"].createElement("div", _extends({
    className: alertClassNames,
    style: {
      '--kt-alert-color': color
    },
    role: "alert"
  }, props), _react["default"].createElement("i", {
    className: "fa fa-info",
    style: {
      '--kt-alert-color': color
    }
  }), _react["default"].createElement("span", {
    className: "kt-alert-title"
  }, title), " ", children);
};

Alert.propTypes = {
  title: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['primary', 'secondary', 'info', 'success', 'warning', 'danger', 'light', 'dark'])
};
Alert.defaultProps = {
  title: '',
  type: 'primary'
};
var _default = Alert;
exports["default"] = _default;